<template>
	<div class="tc">
		<!-- <el-empty 
			:description="description" 
			image="../../../static/empty.png"
			:image-size="300"
		></el-empty> -->
		<img style="width: 292px;margin: 0 auto 25px;" src="../../../static/empty.png" alt="">
		<div class="color9">{{description}}</div>
	</div>
</template>

<script>
	export default{
		props:{
			description:{
				type:String,
				default:'暂无数据'
			}
		},
		data(){
			return{
				
			}
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/noData/index.vue